module.exports = __webpack_public_path__ + "static/media/inventory-clearance-event-logo.396685ec.webp";